import React, { FC } from "react";
import { IdleDetailingItem } from "../../../../../../../../types/service/dashboard/IWorksDashboardService";
import st from './IdlesStackedBarsLegend.module.scss';
import { useMergedIdles } from "../../hooks/useMergedIdles";
import IdlesTooltip from "../IdlesTooltip/IdlesTooltip";

type IdlesStackedBarsLegendProps = {
    idle: IdleDetailingItem
}

const IdlesStackedBarsLegend: FC<IdlesStackedBarsLegendProps> = (props) => {
    const {idle} = props;

    const mergedIdles = useMergedIdles(idle.plannedIdlesByType, idle.unplannedIdlesByType);

    return (
        <div className={st['legend']}>
            <IdlesTooltip
                variant={'legend'}
                dataToRender={mergedIdles}
            />
        </div>
    )
}

export default IdlesStackedBarsLegend